import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import cs from '@emoji-mart/data/i18n/cs.json';
import de from '@emoji-mart/data/i18n/de.json';
import en_gb from '@emoji-mart/data/i18n/en.json';
import en_us from '@emoji-mart/data/i18n/en.json';
import es_es from '@emoji-mart/data/i18n/es.json';
import fi from '@emoji-mart/data/i18n/fi.json';
import fr from '@emoji-mart/data/i18n/fr.json';
import it from '@emoji-mart/data/i18n/it.json';
import ja from '@emoji-mart/data/i18n/ja.json';
// import ko from '@emoji-mart/data/i18n/ko.json';
import nl from '@emoji-mart/data/i18n/nl.json';
import pl from '@emoji-mart/data/i18n/pl.json';
import pt_br from '@emoji-mart/data/i18n/pt.json';
import pt_pt from '@emoji-mart/data/i18n/pt.json';
import ru from '@emoji-mart/data/i18n/ru.json';
import tr from '@emoji-mart/data/i18n/tr.json';
import uk from '@emoji-mart/data/i18n/uk.json';
import zh from '@emoji-mart/data/i18n/zh.json';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import i18n from '../../i18n';
import { SupportedLanguage } from '../../types/SupportedLanguage';

const translations: {
  [key in SupportedLanguage]?: any;
} = {
  // bg language without translation
  // ca language without translation
  cs,
  // da language without translation
  de,
  // el language without translation
  en_gb,
  en_us,
  es_es,
  // es_va language without translation
  // eu language without translation
  fi,
  fr,
  // gl language without translation
  // hu language without translation
  it,
  ja,
  // ko,
  nl,
  // no language without translation
  pl,
  pt_br,
  pt_pt,
  // ro language without translation
  ru,
  // sv language without translation
  tr,
  uk,
  zh,
};

const EmojiPicker = ({ onEmojiSelect }: { onEmojiSelect: (emoji: string) => void }) => {
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const pickerRef = useRef<HTMLDivElement>(null);
  const currentLanguage = i18n.language.toLowerCase();

  useLayoutEffect(() => {
    if (showPicker) {
      containerRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }, [showPicker]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showPicker && pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        setShowPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()} ref={containerRef}>
      <span
        className="cursor-pointer"
        onMouseDown={
          showPicker
            ? undefined
            : (e) => {
                e.stopPropagation();
                setShowPicker(true);
              }
        }
      >
        😀
      </span>
      {showPicker && (
        <div className="absolute right-0 z-10" ref={pickerRef}>
          <Picker
            data={data}
            onEmojiSelect={(e: any) => onEmojiSelect(e.native)}
            i18n={translations[currentLanguage] || translations.en_us}
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
